var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--exit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M5 6h24v24H5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--exit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 19.054l3.073 3.073c.139.138.313.21.522.213a.707.707 0 00.532-.213.718.718 0 00.217-.527.718.718 0 00-.217-.527L18.054 18l3.073-3.073a.726.726 0 00.213-.522.708.708 0 00-.213-.532.718.718 0 00-.527-.217.718.718 0 00-.527.217L17 16.946l-3.073-3.073a.726.726 0 00-.522-.212.708.708 0 00-.532.212.718.718 0 00-.217.527c0 .206.072.382.217.527L15.946 18l-3.073 3.073a.726.726 0 00-.212.522.707.707 0 00.212.532c.145.145.32.217.527.217a.718.718 0 00.527-.217L17 19.054zm.002 8.446a9.254 9.254 0 01-3.705-.748 9.596 9.596 0 01-3.018-2.03 9.595 9.595 0 01-2.03-3.016 9.246 9.246 0 01-.749-3.704c0-1.314.25-2.55.748-3.705a9.595 9.595 0 012.03-3.018 9.593 9.593 0 013.016-2.03 9.246 9.246 0 013.704-.749c1.314 0 2.55.25 3.705.748a9.595 9.595 0 013.018 2.03 9.593 9.593 0 012.03 3.016 9.247 9.247 0 01.749 3.704c0 1.314-.25 2.55-.748 3.705a9.596 9.596 0 01-2.03 3.018 9.595 9.595 0 01-3.016 2.03 9.247 9.247 0 01-3.704.749zM17 26c2.233 0 4.125-.775 5.675-2.325C24.225 22.125 25 20.233 25 18c0-2.233-.775-4.125-2.325-5.675C21.125 10.775 19.233 10 17 10c-2.233 0-4.125.775-5.675 2.325C9.775 13.875 9 15.767 9 18c0 2.233.775 4.125 2.325 5.675C12.875 25.225 14.767 26 17 26z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--exit-31ae9f5b5be343e481b90f82ae77b1c2.svg";
export { SvgIconCircleLimeExit as Component };